import { SharingLinkInfo } from 'owa-link-data';
import getLinkText from '../getLinkText';

export function getDisplayName(
    anchorElement: HTMLAnchorElement,
    sharingLinkInfo: SharingLinkInfo,
    hasValidFileName: boolean,
    shouldBeautify: boolean,
    isLinkPreviouslyBeautified: boolean
): string {
    if (isLinkPreviouslyBeautified) {
        return getLinkText(anchorElement);
    }

    if (hasValidFileName && shouldBeautify) {
        return sharingLinkInfo.fileName;
    }

    return anchorElement.text;
}
